module.exports = __webpack_public_path__ + "img/btn.0b1a4473.png";